// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file controls/v1/control_status.proto (package controls.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file controls/v1/control_status.proto.
 */
export const file_controls_v1_control_status: GenFile = /*@__PURE__*/
  fileDesc("CiBjb250cm9scy92MS9jb250cm9sX3N0YXR1cy5wcm90bxILY29udHJvbHMudjEq5wEKDUNvbnRyb2xTdGF0dXMSHgoaQ09OVFJPTF9TVEFUVVNfVU5TUEVDSUZJRUQQABIcChhDT05UUk9MX1NUQVRVU19WQUxJREFURUQQARIWChJDT05UUk9MX1NUQVRVU19HQVAQAhIeChpDT05UUk9MX1NUQVRVU19OT19FVklERU5DRRADEiAKHENPTlRST0xfU1RBVFVTX05PVF9FVkFMVUFURUQQBBIhCh1DT05UUk9MX1NUQVRVU19OT1RfQVBQTElDQUJMRRAFEhsKF0NPTlRST0xfU1RBVFVTX0FUVEVTVEVEEAZCswEKD2NvbS5jb250cm9scy52MUISQ29udHJvbFN0YXR1c1Byb3RvUAFaP2dpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vY29udHJvbHMvdjE7Y29udHJvbHN2MaICA0NYWKoCC0NvbnRyb2xzLlYxygILQ29udHJvbHNcVjHiAhdDb250cm9sc1xWMVxHUEJNZXRhZGF0YeoCDENvbnRyb2xzOjpWMWIGcHJvdG8z");

/**
 * @generated from enum controls.v1.ControlStatus
 */
export enum ControlStatus {
  /**
   * @generated from enum value: CONTROL_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTROL_STATUS_VALIDATED = 1;
   */
  VALIDATED = 1,

  /**
   * @generated from enum value: CONTROL_STATUS_GAP = 2;
   */
  GAP = 2,

  /**
   * @generated from enum value: CONTROL_STATUS_NO_EVIDENCE = 3;
   */
  NO_EVIDENCE = 3,

  /**
   * @generated from enum value: CONTROL_STATUS_NOT_EVALUATED = 4;
   */
  NOT_EVALUATED = 4,

  /**
   * @generated from enum value: CONTROL_STATUS_NOT_APPLICABLE = 5;
   */
  NOT_APPLICABLE = 5,

  /**
   * @generated from enum value: CONTROL_STATUS_ATTESTED = 6;
   */
  ATTESTED = 6,
}

/**
 * Describes the enum controls.v1.ControlStatus.
 */
export const ControlStatusSchema: GenEnum<ControlStatus> = /*@__PURE__*/
  enumDesc(file_controls_v1_control_status, 0);

